import sectionHeadingCss from '../css-snippets/section-heading';

const html = `
<style>${sectionHeadingCss}</style>
<div data-attribute="card-container" data-background="#7c73ac" data-text-color="#ffffff" style="background-color: #7c73ac; color: #ffffff;">
    <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF" style="background-color: transparent;">
        <div class="wrap-card container">
           <div class="card-content">
                <h2 data-attribute="card-title" class="card-title">What Can The Inex-Air Do For You?</h2>
                <p data-attribute="card-description" class="card-description">Choose a category below for a detailed insight on how the Inex-Air can better your life.</p>
           </div>
        </div>
    </div>
</div>
`;
export default html;
